import axios from 'axios';

export default function User() {
    const fetchUsers = async () => {
        let axiosT = axios.create({
            baseURL: `${process.env.REACT_APP_FEATURED_API}auth/user/`,
            headers: {
                Authorization: `JWT ${localStorage.getItem("token")}`, // token has user data so /profile knows which (signed in) user to get
            },
        });
        return axiosT
            .get("/")
            .then((res) => {
                return res.data.users;
            })
            .catch((err) => {
                console.error("failed to fetch users", err);
            });
    };

    const toggleAdmin = async (user_id, is_staff) => {
        let axiosT = axios.create({
            baseURL: `${process.env.REACT_APP_FEATURED_API}auth/user/`,
            headers: {
                Authorization: `JWT ${localStorage.getItem("token")}`,
            },
        });

        try {
            const response = await axiosT.put(`${user_id}/toggle-admin/`, {
                is_staff: is_staff,  // send req with updated admin status (0/1)
            });

            // success, return user_id and new status
            console.log(response.data);
            return {
                user_id: user_id,
                is_staff: response.data.is_staff
            };
        } catch (error) {
            // failure, return the old status
            console.error("Failed to update user admin status", error);

            throw error;
        }
    };

    const toggleActive = async (user_id, is_active) => {
        let axiosT = axios.create({
            baseURL: `${process.env.REACT_APP_FEATURED_API}auth/user/`,
            headers: {
                Authorization: `JWT ${localStorage.getItem("token")}`,
            },
        });

        try {
            const response = await axiosT.put(`${user_id}/toggle-active/`, {
                is_active: is_active,  // send req with updated status (0/1)
            });

            // success, return user_id and new status
            console.log(response.data);
            return {
                user_id: user_id,
                is_active: response.data.is_active
            };
        } catch (error) {
            // failure, return the old status
            console.error("Failed to update user active status", error);

            throw error;
        }
    };

    const updateUserProfile = async (user_id, updatedUserProfile) => {
        let axiosT = axios.create({
            baseURL: `${process.env.REACT_APP_FEATURED_API}auth/profile/`,
            headers: {
                Authorization: `JWT ${localStorage.getItem("token")}`,
            },
        });

        try {
          const response = await axiosT.put(`${user_id}/`, updatedUserProfile);
            return {
                user_id: user_id,
                userProfile: response.data.user_profile
            };
        } catch (error) {
            console.error(`Failed to update profile for user ${user_id}`, error);

            throw error;
        }
    };

    return {
        fetchUsers,
        toggleAdmin,
        toggleActive,
        updateUserProfile,
    };
}